import {ActionMenuContentSectionBalance} from '#/components/actionmenu/content/action-menu-content-section-balance';
import {ActionMenuContentSectionDemographics} from '#/components/actionmenu/content/action-menu-content-section-demographics';
import {ActionMenuContentSectionInformation} from '#/components/actionmenu/content/action-menu-content-section-information';
import {ActionMenuContentSectionMap} from '#/components/actionmenu/content/action-menu-content-section-map';
import {ActionMenuContentSectionMarketPrice} from '#/components/actionmenu/content/action-menu-content-section-market-price';
import {WalletContext} from '#/contexts/wallet-provider';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {FunctionComponent, useContext} from 'react';
import {useLocation} from 'react-use';

export const ActionMenuInformationInfoTab: FunctionComponent = () => {
  const {
    accountResult: {isConnected},
  } = useContext(WalletContext);
  const location = useLocation();

  return (
    <>
      {isConnected && <ActionMenuContentSectionBalance />}
      <ActionMenuContentSectionInformation />
      <ActionMenuContentSectionDemographics />
      <ActionMenuContentSectionMarketPrice />
      {location.pathname !== ExchangeRoute.MAP && <ActionMenuContentSectionMap />}
    </>
  );
};
